module.exports = __webpack_public_path__ + "static/img/200323.ee45fec8.png";